import React, {useLayoutEffect, useState} from "react"

import Popover from "../../../../core/gd-components/gd-popover/popover"
import PopoverMenuHeader from "../../../../core/gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuOptionWithSubmenu from "../../../../core/gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOption from "../../../../core/gd-components/popover-menu/popover-menu/menu-option"
import PopoverMenuSeparator from "../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import {QuickAddItemType} from "../../../../app/quick-add/@types"
import newProject_getMyTemplates from "../../../../app/quick-add/sections/project/helper/get-my-templates"
import PopoverMenuOptionWithCustomPopover from "../../../../core/gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover"
import ArrayUtils from "../../../../core/gd/utils/array"
import ProjectSession from "../../../../core/model2/project/project-session"
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const"
import menuAdd_getProjectTemplates from "./functions/get-project-templates"
import menuAdd_getPageTemplates from "./functions/get-page-templates"
import newPage_getMyTemplates from "../../../../app/quick-add/sections/structure/page/helpers/get-my-templates"
import menuAdd_getEmbedOptions from "./functions/get-embed-options"
import {EmbedType} from "../../../../core/gd/const/embed/embed-type"
import {TagType} from "../../../../app/quick-add/sections/tag/const"
import NavigationMenuAdd_PopoverNewView from "./add-view/add-view";

type Props = {
    className?      : string

    projectId?      : ID

    getTargetFunc   : func
    hidePopover     : func

    onAddInline     : {(inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams):void}
}

export type NavigationMenuInlineAddParams = {
    templateId?     : ID
    embedType?      : EmbedType

    isEmpty?        : boolean // for folders
}

export enum NavigationMenuInlineAddType {
    FOLDER  = 'folder',
    PAGE    = 'page',
    GROUP   = 'group',
    LINK    = 'link',
    EMBED   = 'embed',
}

const debug = false
// const debug = "NavigationMenuAddPopover"

export default function NavigationMenuAddPopover(props:Props) {

    const [embedOptions, setEmbedOptions] = useState<any[] | null>(null)

    let popoversOpen: any[] = []

    const onAddSubfolder = () => {
        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.FOLDER)
        props.hidePopover()
    }

    const onAddEmptyFolder = () => {
        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.FOLDER, {isEmpty: true})
        props.hidePopover()
    }

    const onAddSubproject = (templateId: ID) => {
        debug && console.log(debug, 'onAddSubproject', props.projectId, templateId)

        gd.openNew(QuickAddItemType.PROJECT, {
            company     : gd.companyId,
            projectId   : props.projectId,
            templateId  : templateId,
        })
        props.hidePopover()
    }

    const onAddFromLibrary = () => {
        debug && console.log(debug, 'onAddFromLibrary')

        gd.openNew(QuickAddItemType.PROJECT, {
            company             : gd.companyId,
            projectId           : props.projectId,
            templatesLibrary    : true
        })
        props.hidePopover()
    }

    const onAddPage = (templateId: ID) => {
        debug && console.log(debug, 'onAddPage', templateId)

        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.PAGE, {templateId})
        props.hidePopover()
    }

    const onAddGroup = () => {
        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.GROUP)
        props.hidePopover()
    }

    const onAddLink = () => {
        debug && console.log(debug, 'onAddLink')
        /*gd.openNew(QuickAddItemType.LINK, {
            company     : gd.companyId,
            projectId   : props.projectId,
        })*/
        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.LINK)
        props.hidePopover()
    }

    const onAddEmbed = (embedType: EmbedType) => {
        debug && console.log(debug, 'onAddEmbed')
        /*gd.openNew(QuickAddItemType.EMBED, {
            company         : gd.companyId,
            projectId       : props.projectId,
            viewSystemType  : viewSystemType,
        })*/
        props.onAddInline && props.onAddInline(NavigationMenuInlineAddType.EMBED, {embedType})
        props.hidePopover()
    }

    const onAddTag = () => {
        gd.openNew(QuickAddItemType.TAG, {
            company     : gd.companyId,
            projectId   : props.projectId,
            type        : props.projectId ? TagType.PROJECT : undefined
        })
        props.hidePopover()
    }

    const onAddTask = () => {
        gd.openNew(QuickAddItemType.TASK, {projectId: props.projectId})
        props.hidePopover()
    }

    const onAddEvent = () => {
        gd.openNew(QuickAddItemType.EVENT, {projectId: props.projectId})
        props.hidePopover()
    }

    const onAddDocument = () => {
        gd.openNew(QuickAddItemType.DOCUMENT, {projectId: props.projectId})
        props.hidePopover()
    }

    const onClickOutside = (e:React.SyntheticEvent) => {
        // if(gd.utils.Dom.findNodeByClassName(e.target, ["popover-submenu", "popover-option-custom",/* "views-dashboard"*/])) return
        if (popoversOpen.length > 0) return
        props.hidePopover()
    }

    const onTogglePopover = (value: boolean, option: any) => {
        if (value) {
            popoversOpen = ArrayUtils.addArrayObject(popoversOpen, option, (o:any)=>_.isEqual(o, option))
        } else {
            popoversOpen = ArrayUtils.removeArrayObject(popoversOpen, option, (o:any)=>_.isEqual(o, option))
        }
    }

    useLayoutEffect(() => {
        const load = async () => {
            const embedOptions = await menuAdd_getEmbedOptions(props.projectId, onAddEmbed)
            setEmbedOptions(embedOptions)
        }

        load()
    }, []);

    const myProjectTemplates        = newProject_getMyTemplates()
    const projectTemplatesOptions   = menuAdd_getProjectTemplates(myProjectTemplates, onAddSubproject, onAddFromLibrary)

    const myPagesTemplates          = newPage_getMyTemplates()
    const pageTemplatesOptions      = menuAdd_getPageTemplates(myPagesTemplates, onAddPage)
    const isAnyPageTemplate         = myPagesTemplates.length > 1

    const project   : ProjectSession | null = gd.session.projects.get(props.projectId)
    const disableNewFolder  = project ? !project.acl.canCreateProject   : false
    const disableNewProject = project ? !project.acl.canCreateProject   : false
    const disableNewTag     = project ? !project.acl.canCreateProject   : false
    const disableNewView    = project ? !project.acl.canCreateProject   : false

    const disableNewPage    = project ? !project.acl.canCreateProject   : false
    const disableNewGroup   = project ? !project.acl.canCreateProject   : false
    const disableNewLink    = project ? !project.acl.canCreateLink      : false
    const disableNewEmbed   = project ? !project.acl.canCreateEmbed     : false

    debug && console.log(debug, 'process acl', disableNewFolder, project?.acl, project)

    if (!embedOptions) return null

    let options: any[] = []

    // folder options
    if (project && !project.isWorkspace) {
        options.push({
            type    : PopoverMenuItemType.POPOVER,
            icon    : 'i5-folder',
            label   : 'Folder',
            disabled: disableNewFolder,
            options : [
                {
                    icon    : 'i5-inherited-folder',
                    // label   : 'Folder (Inherited Views)',
                    // label   : 'Folder & Inherit Views',
                    label   : 'Folder (Inherit Views)',
                    // label   : 'Folder with Inherited Views',
                    hint    : 'Create a folder and inherit views from its parent folder.',
                    onClick : onAddSubfolder
                },

                {
                    icon    : 'i5-folder',
                    label   : 'Folder (Empty)',
                    // label   : 'Empty Folder',
                    // label   : 'Subfolder without Views',
                    hint    : 'Create an empty folder',
                    onClick : onAddEmptyFolder
                },

            ]
        })
    } else {
        options.push({
            icon        : 'i5-folder',
            label       : 'Folder',
            disabled    : disableNewFolder,
            onClick     : onAddEmptyFolder
        })
    }

    options = options.concat([
        {
            type        : PopoverMenuItemType.POPOVER,
            icon        : 'i5-project',
            label       : 'Project', // From Template
            disabled    : disableNewProject,
            options     : [
                // {type: 'header',        label: 'Add Project'},
                ...projectTemplatesOptions
            ]
        },
        {
            type        : isAnyPageTemplate ? PopoverMenuItemType.POPOVER : null,
            icon        : 'ii5-task-list',
            label       : 'Page',
            disabled    : disableNewPage,
            onClick     : onAddPage,
            options     : [
                ...pageTemplatesOptions
            ]
        }
    ])

    options.push({
        type                : PopoverMenuItemType.CUSTOM_POPOVER,
        icon                : 'i5-view',
        label               : 'View',
        disabled            : disableNewView, //!project,
        menuComponent       : NavigationMenuAdd_PopoverNewView,
        popoverClass        : 'ui-menu-add-view-popover',
        menuParams          : {
            projectId   : props.projectId,
        }
    })

    options.push({type: PopoverMenuItemType.SEPARATOR})

    options.push({
        icon        : 'i5-group',
        label       : 'Group',
        disabled    : disableNewGroup,
        onClick     : onAddGroup
    })
    options.push({
        type        : PopoverMenuItemType.POPOVER,
        icon        : 'i5-embeded-code',
        label       : 'Embed',
        disabled    : disableNewEmbed,
        options     : [
            ...embedOptions
        ]
    })
    options.push({
        icon: 'i5-copy-link',
        label: 'Link',
        disabled: disableNewLink,
        onClick: onAddLink
    })
    options.push({
        icon        : 'i5-tag',
        label       : 'Tag',
        disabled    : disableNewTag,
        onClick     : onAddTag
    })




    // show Work item options only for project
    if (project) {
        const showWorkItemsOption   = project.acl.canCreateTask || project.acl.canCreateEvent || project.acl.canCreateDocument

        if (showWorkItemsOption) {
            options.push({type: 'separator'})
            options.push({
                type    : 'popover',
                icon    : 'i5-tasks',
                label   : 'Work item',
                options : [
                    // {type: 'header',        label: 'Add Work item'},
                    {icon: 'i5-task',       label: 'Task',      disabled: !project.acl.canCreateTask,      onClick: onAddTask},
                    {icon: 'i5-calendar',   label: 'Event',     disabled: !project.acl.canCreateEvent,     onClick: onAddEvent},
                    {icon: 'i5-document',   label: 'Document',  disabled: !project.acl.canCreateDocument,  onClick: onAddDocument},
                ]
            })
        }
    }

    return (
        <Popover popoverClass               = "ui-menu-more-popover"
                 autoVisibleTarget          = {true}
                 offset                     = "0 0"
                 constraints                = {[{
                     to         : 'window',
                     attachment : 'together',
                     pin        : true
                 }]}
                 attachment                 = "top left"
                 targetAttachment           = "top right"
                 attachmentType             = "vertical"
                 arrowsVersion              = {2}
                 getTargetFunc              = {props.getTargetFunc}
                 onClickOutside             = {onClickOutside}>

            <div className="ui5-popover-menu min-w-200">
                {_.map(options, (option:any, key:number)=> {

                    switch (option.type) {

                        case PopoverMenuItemType.SEPARATOR:
                            return <PopoverMenuSeparator key={key}/>
                        case PopoverMenuItemType.HEADER:
                            return <PopoverMenuHeader key={key} title={option.label}/>
                        case PopoverMenuItemType.POPOVER:
                            return <PopoverMenuOptionWithSubmenu key                = {'popover_{0}'.f(key)}
                                                                 menuClassName      = 'icon-fs-16'
                                                                 showMenuSelection  = {false}
                                                                 option             = {option}
                                                                 onTogglePopover    = {(value: boolean)=>{onTogglePopover(value, option)}}/>
                        case PopoverMenuItemType.CUSTOM_POPOVER:
                            return <PopoverMenuOptionWithCustomPopover key              = {'popover_{0}'.f(key)}
                                                                       option           = {option}
                                                                       disabled         = {option.disabled}
                                                                       menuParams       = {option.menuParams}
                                                                       onTogglePopover  = {(value: boolean)=>{onTogglePopover(value, option)}}/>
                        default:
                            return <PopoverMenuOption key       = {key}
                                                      option    = {option}/>
                    }

                })}
            </div>
        </Popover>
    )
}